import { API_METHOD } from 'modules/api/constants'
import closeModalAction from 'modules/modal/actions/close'
import openModalAction from 'modules/modal/actions/open'
import { MODAL_ID } from 'modules/modal/constants/index.cjs'
import { ORDERS_ENDPOINT } from 'modules/orders/constants/index.cjs'
import { saveLegacyReduxAction } from 'modules/redux/actions/legacy/save'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import { STYLES_COLOR } from 'modules/styles/constants/index.cjs'

/**
 * Cancels the given order.
 * @param  {Order} instance
 * @returns {Function}
 */
function cancelOrderAction (instance) {
  return dispatch => {
    dispatch(
      openModalAction(MODAL_ID.CONFIRM, {
        message: 'Are you sure you want to cancel your order?',
        confirmLabel: 'Cancel Order',
        confirmColor: STYLES_COLOR.RED,
        onClickConfirm: () => dispatch(
          saveLegacyReduxAction({
            endpoint: ORDERS_ENDPOINT.CANCEL,
            method: API_METHOD.POST,
            path: getPathReduxUtil(instance),
            data: {
              id: getIdReduxUtil(instance)
            }
          })
        )
          .then(() => {
            dispatch(
              closeModalAction()
            )
          }),
        onClickCancel: () => {
          dispatch(
            closeModalAction()
          )
        }
      })
    )
  }
}

export {
  cancelOrderAction
}
